import { RenderType, IMetricSelectMultipleCompValue } from '../types';
import databrainSvg from '@/pages/intelligence/assets/svg/pcConsoleBenchmark/databrain.svg';
import steamDatabaseSvg from '@/pages/intelligence/assets/svg/pcConsoleBenchmark/steamdatabase.svg';
import mscienceSvg from '@/pages/intelligence/assets/svg/pcConsoleBenchmark/msciencenew.svg';
import vginsightsSvg from '@/pages/intelligence/assets/svg/pcConsoleBenchmark/vginsightsnew.svg';
import newzooSvg from '@/pages/home/assets/svg/dataSource/databarin.svg';
// import newzooSvg from '@/pages/intelligence/assets/svg/pcConsoleBenchmark/newzoonew.svg';
import steamSvg from '@/pages/intelligence/assets/svg/pcConsoleBenchmark/steamnew.svg';
import youtubeSvg from '@/pages/intelligence/assets/svg/pcConsoleBenchmark/youtube.svg';
import twitchSvg from '@/pages/intelligence/assets/svg/pcConsoleBenchmark/twitch.svg';
import discordSvg from '@/pages/intelligence/assets/svg/pcConsoleBenchmark/discord.svg'

export const getMetricsDataByCategory = (
  category: string,
): {
  options: any[];
  values: string[];
} => {
  const result: {
    options: any[];
    values: string[];
  } = {
    options: [],
    values: [],
  };
  const metricsTemp = METRICS?.[category];
  if (!Array.isArray(metricsTemp)) return result;

  for (const metric of metricsTemp) {
    if (metric?.categoryKey === category) {
      result.values.push(metric?.value);
      result.options.push({
        ...metric,
        icon: METRIC_DATASOURCE_ICON?.[metric?.dataSourceKey],
      });
    }
  }

  return result;
};


export const transferMetricToConfig = (value: IMetricSelectMultipleCompValue) => {
  const metricsTemp = METRICS?.[value?.category];
  if (Array.isArray(metricsTemp)) {
    return metricsTemp?.filter((t) => {
      return value?.metrics?.includes(t?.value);
    });
  }
  return [];
};

// 指标分类key 常量map
export const METRIC_CATEGORY_KEYS = {
  US_Digital_Revenue: 'us_digital_revenue',
  BASIC_INFO: 'basic_info',
  BUSINESS: 'business',
  PLAYER_ACTIVITY: 'player_activity',
  SOCAIL_CHANNELS: 'socail_channels',
};

// 指标数据源key 常量map
export const METRIC_DATASOURCE_KEYS = {
  DATABRAIN: 'databrain',
  MSCIENCE: 'mscience',
  STEAMDB: 'steam_db',
  IGDB: 'igdb',
  VG_INSIGHTS: 'vg_insights',
  NEWZOO: 'newzoo',
  STEAMCHARTS: 'steamcharts',
  STEAM: 'steam',
  STEAMSPY: 'steamspy',
  YOUTUBE: 'youtube',
  TWITCH: 'twitch',
  DISCORD: 'discord',
};


export const METRIC_DATASOURCE_ICON = {
  [METRIC_DATASOURCE_KEYS.DATABRAIN]: databrainSvg,
  [METRIC_DATASOURCE_KEYS.MSCIENCE]: mscienceSvg,
  [METRIC_DATASOURCE_KEYS.STEAMDB]: steamDatabaseSvg,
  [METRIC_DATASOURCE_KEYS.IGDB]: '',
  [METRIC_DATASOURCE_KEYS.VG_INSIGHTS]: vginsightsSvg,
  [METRIC_DATASOURCE_KEYS.NEWZOO]: newzooSvg,
  [METRIC_DATASOURCE_KEYS.STEAMCHARTS]: steamSvg,
  [METRIC_DATASOURCE_KEYS.STEAM]: steamSvg,
  [METRIC_DATASOURCE_KEYS.STEAMSPY]: steamSvg,
  [METRIC_DATASOURCE_KEYS.YOUTUBE]: youtubeSvg,
  [METRIC_DATASOURCE_KEYS.TWITCH]: twitchSvg,
  [METRIC_DATASOURCE_KEYS.DISCORD]: discordSvg,
};

// 指标
export const METRICS = {
  // [METRIC_CATEGORY_KEYS.US_Digital_Revenue]: USDigitalRevenue,
  [METRIC_CATEGORY_KEYS.BASIC_INFO]: [
    {
      categoryKey: METRIC_CATEGORY_KEYS.BASIC_INFO,
      dataSourceKey: METRIC_DATASOURCE_KEYS.DATABRAIN,
      dataSourceName: 'DataBrain',
      value: 'earlest_data_date',
      text: 'Earliest data of date',
      text_zh: '最高有数据的日期',
      width: 240,
      renderType: RenderType.TEXT, //默认RenderType.VALUE_ONLY,
      hasSort: true, //默认true
    },
    {
      categoryKey: METRIC_CATEGORY_KEYS.BASIC_INFO,
      dataSourceKey: METRIC_DATASOURCE_KEYS.DATABRAIN,
      dataSourceName: 'DataBrain',
      value: 'db_release_date',
      text: 'Release date',
      text_zh: '发行日期',
      width: 180,
      renderType: RenderType.TEXT,
      hasSort: true,
    },
    {
      categoryKey: METRIC_CATEGORY_KEYS.BASIC_INFO,
      dataSourceKey: METRIC_DATASOURCE_KEYS.DATABRAIN,
      dataSourceName: 'DataBrain',
      value: 'developer',
      text: 'Developer',
      text_zh: '开发商',
      width: 200,
      renderType: RenderType.TEXT,
      hasSort: false,
      className: 'general-table-img-text__left',
    },
    {
      categoryKey: METRIC_CATEGORY_KEYS.BASIC_INFO,
      dataSourceKey: METRIC_DATASOURCE_KEYS.DATABRAIN,
      dataSourceName: 'DataBrain',
      value: 'publisher',
      text: 'Publisher',
      text_zh: '发行商',
      width: 200,
      renderType: RenderType.TEXT,
      hasSort: false,
      className: 'general-table-img-text__left',
    },
    {
      categoryKey: METRIC_CATEGORY_KEYS.BASIC_INFO,
      dataSourceKey: METRIC_DATASOURCE_KEYS.DATABRAIN,
      dataSourceName: 'DataBrain',
      value: 'iegg_genre',
      text: 'Genre',
      text_zh: '品类',
      width: 180,
      renderType: RenderType.TEXT,
      hasSort: false,
      className: 'general-table-img-text__left',
    },
    {
      categoryKey: METRIC_CATEGORY_KEYS.BASIC_INFO,
      dataSourceKey: METRIC_DATASOURCE_KEYS.DATABRAIN,
      dataSourceName: 'DataBrain',
      value: 'iegg_sub_genre',
      text: 'Sub Genre',
      text_zh: '副品类',
      width: 200,
      renderType: RenderType.TEXT,
      hasSort: false,
      className: 'general-table-img-text__left',
    },
    {
      categoryKey: METRIC_CATEGORY_KEYS.BASIC_INFO,
      dataSourceKey: METRIC_DATASOURCE_KEYS.MSCIENCE,
      dataSourceName: 'Mscience',
      value: 'biz_model',
      text: 'Biz Model',
      text_zh: '商业模式',
      width: 180,
      renderType: RenderType.TEXT,
      hasSort: false,
      className: 'general-table-img-text__left',
    },
    {
      categoryKey: METRIC_CATEGORY_KEYS.BASIC_INFO,
      dataSourceKey: '',
      dataSourceName: '',
      value: 'current_stage',
      text: 'Current Stage (EA/FL)',
      text_zh: '当前阶段（EA/FL）',
      width: 220,
      renderType: RenderType.TEXT,
      hasSort: false,
      className: 'general-table-text',
    },
    {
      categoryKey: METRIC_CATEGORY_KEYS.BASIC_INFO,
      dataSourceKey: METRIC_DATASOURCE_KEYS.DATABRAIN,
      dataSourceName: 'DataBrain',
      value: 'storage_(gb)',
      text: 'Storage (GB)',
      text_zh: '存储空间（GB）',
      width: 180,
      renderType: RenderType.TEXT,
      hasSort: false,
      className: 'general-table-img-text__left',
    },
    {
      categoryKey: METRIC_CATEGORY_KEYS.BASIC_INFO,
      dataSourceKey: METRIC_DATASOURCE_KEYS.STEAMDB,
      dataSourceName: 'SteamDB',
      value: 'Minimum:Memory',
      text: 'Min RAM',
      text_zh: '最小内存',
      width: 150,
      renderType: RenderType.TEXT,
      hasSort: false,
      className: 'general-table-img-text__left',
    },
    {
      categoryKey: METRIC_CATEGORY_KEYS.BASIC_INFO,
      dataSourceKey: METRIC_DATASOURCE_KEYS.STEAMDB,
      dataSourceName: 'SteamDB',
      value: 'Minimum:Storage',
      text: 'Min HDD',
      text_zh: '最小硬盘',
      width: 200,
      renderType: RenderType.TEXT,
      hasSort: false,
      className: 'general-table-img-text__left',
    },
    {
      categoryKey: METRIC_CATEGORY_KEYS.BASIC_INFO,
      dataSourceKey: METRIC_DATASOURCE_KEYS.STEAMDB,
      dataSourceName: 'SteamDB',
      value: 'Minimum:Processor',
      text: 'Min Processor',
      text_zh: '最小处理器',
      width: 200,
      renderType: RenderType.TEXT,
      hasSort: false,
      className: 'general-table-img-text__left',
    },
    {
      categoryKey: METRIC_CATEGORY_KEYS.BASIC_INFO,
      dataSourceKey: METRIC_DATASOURCE_KEYS.STEAMDB,
      dataSourceName: 'SteamDB',
      value: 'Minimum:Graphics',
      text: 'Min Graphics',
      text_zh: '最小图形处理器',
      width: 260,
      renderType: RenderType.TEXT,
      hasSort: false,
      className: 'general-table-img-text__left',
    },
    {
      categoryKey: METRIC_CATEGORY_KEYS.BASIC_INFO,
      dataSourceKey: METRIC_DATASOURCE_KEYS.STEAMDB,
      dataSourceName: 'SteamDB',
      value: 'Minimum:OS',
      text: 'Min OS',
      text_zh: '最小操作系统',
      width: 230,
      renderType: RenderType.TEXT,
      hasSort: false,
      className: 'general-table-img-text__left',
    },
    {
      categoryKey: METRIC_CATEGORY_KEYS.BASIC_INFO,
      dataSourceKey: METRIC_DATASOURCE_KEYS.STEAMDB,
      dataSourceName: 'SteamDB',
      value: 'Recommended:Memory',
      text: 'Recom. RAM',
      text_zh: '推荐 内存',
      renderType: RenderType.TEXT,
      hasSort: false,
      className: 'general-table-img-text__left',
    },
    {
      categoryKey: METRIC_CATEGORY_KEYS.BASIC_INFO,
      dataSourceKey: METRIC_DATASOURCE_KEYS.STEAMDB,
      dataSourceName: 'SteamDB',
      value: 'Recommended:Storage',
      text_zh: '推荐 硬盘',
      text: 'Recom. HDD',
      width: 200,
      renderType: RenderType.TEXT,
      hasSort: false,
      className: 'general-table-img-text__left',
    },
    {
      categoryKey: METRIC_CATEGORY_KEYS.BASIC_INFO,
      dataSourceKey: METRIC_DATASOURCE_KEYS.STEAMDB,
      dataSourceName: 'SteamDB',
      value: 'Recommended:Processor',
      text: 'Recom. Processor',
      text_zh: '推荐 处理器',
      width: 200,
      renderType: RenderType.TEXT,
      hasSort: false,
      className: 'general-table-img-text__left',
    },
    {
      categoryKey: METRIC_CATEGORY_KEYS.BASIC_INFO,
      dataSourceKey: METRIC_DATASOURCE_KEYS.STEAMDB,
      dataSourceName: 'SteamDB',
      value: 'Recommended:Graphics',
      text: 'Recom. Graphics',
      text_zh: '推荐 显卡',
      width: 230,
      renderType: RenderType.TEXT,
      hasSort: false,
      className: 'general-table-img-text__left',
    },
    {
      categoryKey: METRIC_CATEGORY_KEYS.BASIC_INFO,
      dataSourceKey: METRIC_DATASOURCE_KEYS.STEAMDB,
      dataSourceName: 'SteamDB',
      value: 'Recommended:OS',
      text: 'Recom. OS',
      text_zh: 'Recom. 操作系统',
      width: 200,
      renderType: RenderType.TEXT,
      hasSort: false,
      className: 'general-table-img-text__left',
    },
    {
      categoryKey: METRIC_CATEGORY_KEYS.BASIC_INFO,
      dataSourceKey: METRIC_DATASOURCE_KEYS.IGDB,
      dataSourceName: '', //'IGDB',
      value: 'PC(MicrosoftWindows)',
      text: 'PC Release Date',
      text_zh: 'PC端发布日期',
      width: 180,
      renderType: RenderType.TEXT,
      hasSort: false,
      className: 'general-table-text',
    },
    {
      categoryKey: METRIC_CATEGORY_KEYS.BASIC_INFO,
      dataSourceKey: METRIC_DATASOURCE_KEYS.IGDB,
      dataSourceName: '', //'IGDB',
      value: 'Xbox Release Date',
      text: 'Xbox Release Date',
      text_zh: 'Xbox端 发布日期',
      width: 180,
      renderType: RenderType.TEXT,
      hasSort: false,
      className: 'general-table-text',
    },
    {
      categoryKey: METRIC_CATEGORY_KEYS.BASIC_INFO,
      dataSourceKey: METRIC_DATASOURCE_KEYS.IGDB,
      dataSourceName: '', //'IGDB',
      value: 'PS Date',
      text: 'PS Release Date',
      text_zh: 'PS端 发布日期',
      width: 180,
      renderType: RenderType.TEXT,
      hasSort: false,
      className: 'general-table-text',
    },
    {
      categoryKey: METRIC_CATEGORY_KEYS.BASIC_INFO,
      dataSourceKey: METRIC_DATASOURCE_KEYS.IGDB,
      dataSourceName: '', //'IGDB',
      value: 'NintendoSwitch',
      text: 'Nintendo Release Date',
      text_zh: '任天堂端 发布日期',
      width: 220,
      renderType: RenderType.TEXT,
      hasSort: false,
      className: 'general-table-text',
    },
  ],
  [METRIC_CATEGORY_KEYS.BUSINESS]: [
    {
      categoryKey: METRIC_CATEGORY_KEYS.BUSINESS,
      dataSourceKey: METRIC_DATASOURCE_KEYS.STEAMDB,
      dataSourceName: 'steamdatabase',
      value: 'vg_earliest_date_price',
      text: 'Earliest date price / Inital price',
      text_zh: '最初价格/初始价格',
      width: 300,
      renderType: RenderType.VALUE_ONLY,
      hasSort: true,
      align: 'right',
      className: 'general-table-img-text__left',
    },
    {
      categoryKey: METRIC_CATEGORY_KEYS.BUSINESS,
      dataSourceKey: METRIC_DATASOURCE_KEYS.STEAMDB,
      dataSourceName: 'steamdatabase',
      value: 'vg_max_price',
      text: 'Max price',
      text_zh: '最高价格',
      width: 150,
      renderType: RenderType.VALUE_ONLY,
      hasSort: true,
      align: 'right',
      className: 'general-table-img-text__left',
    },
    {
      categoryKey: METRIC_CATEGORY_KEYS.BUSINESS,
      dataSourceKey: METRIC_DATASOURCE_KEYS.STEAMDB,
      dataSourceName: 'steamdatabase',
      value: 'vg_min_price',
      text: 'Min price',
      text_zh: '最低价格',
      width: 150,
      renderType: RenderType.VALUE_ONLY,
      hasSort: true,
      align: 'right',
      className: 'general-table-img-text__left',
    },
    {
      categoryKey: METRIC_CATEGORY_KEYS.BUSINESS,
      dataSourceKey: METRIC_DATASOURCE_KEYS.STEAMDB,
      dataSourceName: 'steamdatabase',
      value: 'vg_weighted_avg_price',
      text: 'Weighted avg price',
      text_zh: '加权平均价',
      width: 220,
      renderType: RenderType.VALUE_ONLY,
      hasSort: true,
      align: 'right',
      className: 'general-table-img-text__left',
    },
    {
      categoryKey: METRIC_CATEGORY_KEYS.BUSINESS,
      dataSourceKey: METRIC_DATASOURCE_KEYS.STEAMDB,
      dataSourceName: 'steamdatabase',
      value: 'vg_current_price',
      text: 'Current price / Latest price',
      text_zh: '当前价格/最新价格',
      width: 270,
      renderType: RenderType.VALUE_ONLY,
      hasSort: true,
      align: 'right',
      className: 'general-table-img-text__left',
    },
    {
      categoryKey: METRIC_CATEGORY_KEYS.BUSINESS,
      dataSourceKey: METRIC_DATASOURCE_KEYS.VG_INSIGHTS,
      dataSourceName: 'VGInsights', //'IGDB',
      value: 'vg_insights_rev',
      text: 'Revenue To Date',
      text_zh: '迄今收入',
      width: 200,
      renderType: RenderType.VALUE_ONLY,
      hasSort: true,
      align: 'right',
      className: 'general-table-img-text__left',
    },
    {
      categoryKey: METRIC_CATEGORY_KEYS.BUSINESS,
      dataSourceKey: METRIC_DATASOURCE_KEYS.VG_INSIGHTS,
      dataSourceName: 'VGInsights', //'IGDB',
      value: 'vg_insights_sold',
      text: 'Units to date',
      text_zh: '迄今销量',
      width: 180,
      renderType: RenderType.VALUE_ONLY,
      hasSort: true,
      align: 'right',
      className: 'general-table-img-text__left',
    },
  ],
  [METRIC_CATEGORY_KEYS.SOCAIL_CHANNELS]: [
    {
      categoryKey: METRIC_CATEGORY_KEYS.SOCAIL_CHANNELS,
      dataSourceKey: METRIC_DATASOURCE_KEYS.STEAM,
      src: METRIC_DATASOURCE_ICON[METRIC_DATASOURCE_KEYS.STEAM],
      dataSourceName: 'Steam',
      value: 'steam_reviews',
      text: 'Reviews',
      text_zh: '评论数',
      width: 200,
      renderType: RenderType.VALUE_ONLY,
      hasSort: true,
    },
    {
      categoryKey: METRIC_CATEGORY_KEYS.SOCAIL_CHANNELS,
      dataSourceKey: METRIC_DATASOURCE_KEYS.STEAM,
      src: METRIC_DATASOURCE_ICON[METRIC_DATASOURCE_KEYS.STEAM],
      dataSourceName: 'Steam',
      value: 'steam_positive_reviews', //格式94%
      text: 'Steam - % Positive Reviews',
      text_zh: 'Steam - 好评率',
      width: 280,
      // renderType: RenderType.GROWTH_ONLY,
      hasSort: true,
    },
    {
      categoryKey: METRIC_CATEGORY_KEYS.SOCAIL_CHANNELS,
      dataSourceKey: METRIC_DATASOURCE_KEYS.STEAMSPY,
      src: METRIC_DATASOURCE_ICON[METRIC_DATASOURCE_KEYS.STEAM],
      dataSourceName: 'Steam', //'SteamSpy',
      value: 'steam_followers',
      text: 'Steam Followers',
      text_zh: 'Steam 关注人数',
      width: 200,
      renderType: RenderType.VALUE_ONLY,
      hasSort: true,
    },
    {
      categoryKey: METRIC_CATEGORY_KEYS.SOCAIL_CHANNELS,
      dataSourceKey: METRIC_DATASOURCE_KEYS.TWITCH,
      src: METRIC_DATASOURCE_ICON[METRIC_DATASOURCE_KEYS.TWITCH],
      dataSourceName: 'Twitch',
      value: 'twitch_avg_views',
      text: 'Avg Concurrent Viewers',
      text_zh: '平均同时观看人数',
      width: 250,
      renderType: RenderType.VALUE_ONLY,
      hasSort: true,
    },
    {
      categoryKey: METRIC_CATEGORY_KEYS.SOCAIL_CHANNELS,
      dataSourceKey: METRIC_DATASOURCE_KEYS.TWITCH,
      src: METRIC_DATASOURCE_ICON[METRIC_DATASOURCE_KEYS.TWITCH],
      dataSourceName: 'Twitch',
      value: 'twitch_avg_streams',
      text: 'Avg Concurrent Streams',
      text_zh: '平均同时在线流',
      width: 260,
      renderType: RenderType.VALUE_ONLY,
      hasSort: true,
    },
    {
      categoryKey: METRIC_CATEGORY_KEYS.SOCAIL_CHANNELS,
      dataSourceKey: METRIC_DATASOURCE_KEYS.TWITCH,
      src: METRIC_DATASOURCE_ICON[METRIC_DATASOURCE_KEYS.TWITCH],
      dataSourceName: 'Twitch',
      value: 'twitch_avg_watch',
      text: 'Avg Hours Watched',
      text_zh: '平均观看时长',
      width: 230,
      renderType: RenderType.VALUE_ONLY,
      hasSort: true,
    },
    {
      categoryKey: METRIC_CATEGORY_KEYS.SOCAIL_CHANNELS,
      dataSourceKey: METRIC_DATASOURCE_KEYS.TWITCH,
      src: METRIC_DATASOURCE_ICON[METRIC_DATASOURCE_KEYS.TWITCH],
      dataSourceName: 'Twitch',
      value: 'twitch_peak_views',
      text: 'Peak Concurrent Viewers',
      text_zh: '平均观看时长',
      width: 260,
      renderType: RenderType.VALUE_ONLY,
      hasSort: true,
    },
    {
      categoryKey: METRIC_CATEGORY_KEYS.SOCAIL_CHANNELS,
      dataSourceKey: METRIC_DATASOURCE_KEYS.TWITCH,
      src: METRIC_DATASOURCE_ICON[METRIC_DATASOURCE_KEYS.TWITCH],
      dataSourceName: 'Twitch',
      value: 'twitch_peak_streams',
      text: 'Peak Concurrent Streams',
      text_zh: '峰值同时在线直播频道数',
      width: 260,
      renderType: RenderType.VALUE_ONLY,
      hasSort: true,
    },
    {
      categoryKey: METRIC_CATEGORY_KEYS.SOCAIL_CHANNELS,
      dataSourceKey: METRIC_DATASOURCE_KEYS.TWITCH,
      src: METRIC_DATASOURCE_ICON[METRIC_DATASOURCE_KEYS.TWITCH],
      dataSourceName: 'Twitch',
      value: 'twitch_peak_watch',
      text: 'Peak Hours Watched',
      text_zh: '峰值观看时长',
      width: 230,
      renderType: RenderType.VALUE_ONLY,
      hasSort: true,
    },
    {
      categoryKey: METRIC_CATEGORY_KEYS.SOCAIL_CHANNELS,
      dataSourceKey: METRIC_DATASOURCE_KEYS.TWITCH,
      src: METRIC_DATASOURCE_ICON[METRIC_DATASOURCE_KEYS.TWITCH],
      dataSourceName: 'Twitch',
      value: 'twitch_sum_streams',
      text: 'Sum Concurrent Streams',
      text_zh: '总同时在线频道数',
      width: 260,
      renderType: RenderType.VALUE_ONLY,
      hasSort: true,
    },
    {
      categoryKey: METRIC_CATEGORY_KEYS.SOCAIL_CHANNELS,
      dataSourceKey: METRIC_DATASOURCE_KEYS.TWITCH,
      src: METRIC_DATASOURCE_ICON[METRIC_DATASOURCE_KEYS.TWITCH],
      dataSourceName: 'Twitch',
      value: 'twitch_sum_watch',
      text: 'Sum Hours Watched',
      text_zh: '总观看时长',
      width: 240,
      renderType: RenderType.VALUE_ONLY,
      hasSort: true,
    },
    {
      categoryKey: METRIC_CATEGORY_KEYS.SOCAIL_CHANNELS,
      dataSourceKey: METRIC_DATASOURCE_KEYS.DISCORD,
      src: METRIC_DATASOURCE_ICON[METRIC_DATASOURCE_KEYS.DISCORD],
      dataSourceName: 'Discord',
      value: 'discord_member_count',
      text: 'Member Count',
      text_zh: '成员数',
      renderType: RenderType.VALUE_ONLY,
      width: 180,
      hasSort: true,
    }
  ],
  [METRIC_CATEGORY_KEYS.PLAYER_ACTIVITY]: [
    {
      categoryKey: METRIC_CATEGORY_KEYS.PLAYER_ACTIVITY,
      dataSourceKey: METRIC_DATASOURCE_KEYS.NEWZOO,
      dataSourceName: 'Newzoo',
      value: 'pc_newzoo_current_mau',
      text: 'PC_Current MAU',
      text_zh: 'PC端当前月活',
      renderType: RenderType.VALUE_ONLY,
      hasSort: true,
      width: 220,
      metricKey: 'mau'
    },
    {
      categoryKey: METRIC_CATEGORY_KEYS.PLAYER_ACTIVITY,
      dataSourceKey: METRIC_DATASOURCE_KEYS.NEWZOO,
      dataSourceName: 'Newzoo',
      value: 'console_newzoo_current_mau',
      text: 'Console_Current MAU',
      text_zh: '主机端当前月活',
      renderType: RenderType.VALUE_ONLY,
      hasSort: true,
      width: 236,
      metricKey: 'mau'
    },
    {
      categoryKey: METRIC_CATEGORY_KEYS.PLAYER_ACTIVITY,
      dataSourceKey: METRIC_DATASOURCE_KEYS.NEWZOO,
      dataSourceName: 'Newzoo',
      value: 'pc_newzoo_peak_mau',
      text: 'PC_Peak. MAU',
      text_zh: 'PC端月活峰值',
      renderType: RenderType.VALUE_ONLY,
      hasSort: true,
      width: 190,
      metricKey: 'mau'
    },
    {
      categoryKey: METRIC_CATEGORY_KEYS.PLAYER_ACTIVITY,
      dataSourceKey: METRIC_DATASOURCE_KEYS.NEWZOO,
      dataSourceName: 'Newzoo',
      value: 'console_newzoo_peak_mau',
      text: 'Console_Peak. MAU',
      text_zh: '主机端月活峰值',
      renderType: RenderType.VALUE_ONLY,
      hasSort: true,
      width: 220,
      metricKey: 'mau'
    },
    {
      categoryKey: METRIC_CATEGORY_KEYS.PLAYER_ACTIVITY,
      dataSourceKey: METRIC_DATASOURCE_KEYS.NEWZOO,
      dataSourceName: 'Newzoo',
      value: 'pc_newzoo_avg_mau',
      text_zh: 'PC端平均月活',
      text: 'PC_Avg. MAU',
      width: 200,
      metricKey: 'mau'
    },
    {
      categoryKey: METRIC_CATEGORY_KEYS.PLAYER_ACTIVITY,
      dataSourceKey: METRIC_DATASOURCE_KEYS.NEWZOO,
      dataSourceName: 'Newzoo',
      value: 'console_newzoo_avg_mau',
      text: 'Console_Avg. MAU',
      text_zh: '主机端月活',
      width: 220,
      metricKey: 'mau'
    },
    {
      categoryKey: METRIC_CATEGORY_KEYS.PLAYER_ACTIVITY,
      dataSourceKey: METRIC_DATASOURCE_KEYS.STEAMCHARTS,
      dataSourceName: 'SteamCharts',
      value: 'steam_30_days_acu',
      text: 'Last 30 days ACU',
      text_zh: '最近 30 天同时在线玩家',
      width: 220,
      renderType: RenderType.VALUE_ONLY,
      hasSort: true,
    },
    {
      categoryKey: METRIC_CATEGORY_KEYS.PLAYER_ACTIVITY,
      dataSourceKey: METRIC_DATASOURCE_KEYS.STEAMCHARTS,
      dataSourceName: 'SteamCharts',
      value: 'steam_30_days_pcu',
      text: 'Last 30 days PCU',
      text_zh: '最近 30 天最高同时在线玩家',
      width: 220,
      renderType: RenderType.VALUE_ONLY,
      hasSort: true,
    },
    {
      categoryKey: METRIC_CATEGORY_KEYS.PLAYER_ACTIVITY,
      dataSourceKey: METRIC_DATASOURCE_KEYS.STEAMCHARTS,
      dataSourceName: 'SteamCharts',
      value: 'steam_lifetime_pcu',
      text: 'Lifetime PCU',
      text_zh: '全生命周期 最高同时在线玩家',
      renderType: RenderType.VALUE_ONLY,
      width: 200,
      hasSort: true,
    },
    {
      categoryKey: METRIC_CATEGORY_KEYS.PLAYER_ACTIVITY,
      dataSourceKey: METRIC_DATASOURCE_KEYS.NEWZOO,
      dataSourceName: 'Newzoo',
      value: 'newzoo_avg_monthly_hours',
      text: 'Avg. Monthly Played Hours',
      text_zh: '平均 每月游玩时长',
      width: 280,
      renderType: RenderType.VALUE_ONLY,
      hasSort: true,
      metricKey: 'avg_monthly_playtime'
    }
  ],
};